import { render } from "./WorkflowNode.vue?vue&type=template&id=aef59242&scoped=true&lang=pug"
import script from "./WorkflowNode.vue?vue&type=script&lang=js"
export * from "./WorkflowNode.vue?vue&type=script&lang=js"

import "./WorkflowNode.vue?vue&type=style&index=0&id=aef59242&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef59242"]])

export default __exports__